import React from 'react';
import { useParams } from 'react-router-dom';
import UpdatePerformance from './UpdatePerformance';

function EditPerformDataPage() {
    const { performance_id } = useParams(); // extract the ID from URL

    return (
        <div className="container-fluid">
            
            <UpdatePerformance performance_id={performance_id} />
        </div>
    );
}

export default EditPerformDataPage;
